import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const TrialBanner = () => {
    const { user } = useAuth();
    const navigate = useNavigate();

    if (!user?.trialUsed || user?.isPaid || (user as any)?.paid) return null;

    // if (!user?.trialUsed || user?.isPaid) return null;

    const scriptsLeft = 2 - (user?.trialScriptsUsed || 0);

    if (scriptsLeft <= 0) {
        return (
            <div className="bg-red-900 border-b border-red-700 px-6 py-3 flex items-center justify-between">
                <span className="text-red-300 text-sm font-semibold">
                    ⚠️ Your free trial has ended! Upgrade to continue enjoying Agency features.
                </span>
                <button
                    onClick={() => navigate('/pricing')}
                    className="bg-red-600 hover:bg-red-700 text-white px-4 py-1 rounded-lg text-sm transition">
                    Upgrade Now
                </button>
            </div>
        );
    }

    return (
        <div className={`border-b px-6 py-3 flex items-center justify-between ${
            scriptsLeft === 1
                ? 'bg-red-900 border-red-700'
                : 'bg-purple-900 border-purple-700'
        }`}>
            <span className="text-sm font-semibold">
                {scriptsLeft === 1 ? '🔴' : '🟢'}
                {' '}Free Trial: <strong>{scriptsLeft} script{scriptsLeft !== 1 ? 's' : ''}</strong> remaining
                {' '}— You're enjoying all Agency features for free!
            </span>
            <button
                onClick={() => navigate('/pricing')}
                className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-1 rounded-lg text-sm transition">
                Upgrade
            </button>
        </div>
    );
};

export default TrialBanner;